import { RootState } from '../../rootReducer'

export const snackbarIsVisible = (state: RootState) => state.snackbar.isVisible
export const snackbarMessage = (state: RootState) => state.snackbar.message
export const snackbarType = (state: RootState) => state.snackbar.type
